<template>
  <div
    class="sidebar"
    :data-color="activeColor"
    :data-image="backgroundImage"
    :data-background-color="backgroundColor"
    :style="sidebarStyle"
  >
    <div class="logo">
      <a href="/" class="simple-text logo-mini" target="_blank">
        <div class="logo-img">
          <img :src="logo" />
        </div>
      </a>
      <a href="/" class="simple-text logo-normal" target="_blank">
        <template v-if="$route.meta.rtlActive">{{ rtlTitle }}</template>
        <template v-else>{{ title }}</template>
      </a>
      <div class="navbar-minimize">
        <md-button
          id="minimizeSidebar"
          class="md-round md-just-icon md-transparent"
          @click="minimizeSidebar"
        >
          <i class="material-icons text_align-center visible-on-sidebar-regular"
            >more_vert</i
          >
          <i
            class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
            >view_list</i
          >
        </md-button>
      </div>
    </div>
    <div ref="sidebarScrollArea" class="sidebar-wrapper">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index2) in link.children"
              :key="subLink.name + index2"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sidebar',
  props: {
    title: {
      type: String,
      default: 'AEGISBOOK'
    },
    activeColor: {
      type: String,
      default: 'blue',
      validator: value => {
        let acceptedValues = [
          '',
          'purple',
          'azure',
          'green',
          'orange',
          'danger',
          'rose'
        ]
        return acceptedValues.indexOf(value) !== -1
      }
    },
    backgroundImage: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'white',
      validator: value => {
        let acceptedValues = ['', 'black', 'white', 'red']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    logo: {
      type: String,
      default: ''
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    },
    isSidebarOpen() {
      return !(document.body.className.match(/\bsidebar-mini\b/) === null)
    }
  },

  watch: {
    $route: function() {
      this.minimizeSidebar()
      this.$sidebar.showSidebar = false
    }
  },

  mounted() {
    if (this.$sidebar.isMinimized === true) {
      this.$sidebar.toggleMinimize()
    }
  },
  created() {},
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  },

  methods: {
    userSelection(userId) {
      this.$store.dispatch('userSelection', userId)
    },

    groupSelection(groupName) {
      this.$store.dispatch('groupSelection', groupName)
    },

    // loadUsers() {

    //   if(this.$route.name == "calendarmultiple" ){
    //     this.$store.dispatch("loadUsers");
    //   }
    // },

    // loadEventTypes() {
    //   this.$store.dispatch("loadEventsTypes");
    // },

    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },

    getGroupUsers(groupName) {
      let users = []
      for (let i = 0; i < this.$store.state.users.length; i++) {
        if (this.$store.state.users[i].group_name === groupName) {
          users.push(this.$store.state.users[i])
        }
      }
      return users
    }
  }
}
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

.sidebar .md-list.user-list .md-list-item-content,
.off-canvas-sidebar .md-list .md-list-item-content {
  height: 40px;
}

.group-title {
  margin-left: 5px;
  background-color: aliceblue;
  font-weight: 600;
}

.group-title .md-checkbox .md-checkbox-label {
  color: black !important;
  pointer-events: none;
}

.md-ripple {
  z-index: 0;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  z-index: 5 !important;
}

.sidebar .logo,
.off-canvas-sidebar .logo {
  padding: 8px 0px !important;
}
</style>
